export function SET_CATEGORIES({ commit }, [categories]) {
    commit('SAVE_CATEGORIES', [categories])
}

export function SET_CATEGORY({ commit }, [category]) {
    commit('SAVE_CATEGORY', [category])
}

export function SET_SEARCH({ commit }, [search]) {
    commit('SAVE_SEARCH', [search])
}